/**
 * Próxima ação padrão do lead novo (CRM-24).
 *
 * O Novo Lead nasce com "Primeiro contato" marcado para o próximo dia útil:
 * sem isso o lead manual ficava fora do sino e de Minhas Pendências até
 * alguém registrar um contato. Data em `YYYY-MM-DD` LOCAL — `toISOString()`
 * colocaria o dia anterior para quem está em São Paulo (ADR-0059).
 */
import { isoLocal } from "./periodoEntrada";

export const PROXIMA_ACAO_PADRAO = "Primeiro contato";

const SABADO = 6;
const DOMINGO = 0;

/** Próximo dia útil (seg–sex) DEPOIS de `base`, como data local YYYY-MM-DD. */
export function proximoDiaUtil(base = new Date()) {
  const data = new Date(base.getFullYear(), base.getMonth(), base.getDate());
  do {
    data.setDate(data.getDate() + 1);
  } while (data.getDay() === SABADO || data.getDay() === DOMINGO);
  return isoLocal(data);
}
